import { InitialLoadEditSources } from '@confluence/edit-common/entry-points/event-names';

export const isLoadingFromCreate = (editSource: string) => editSource?.indexOf('CREATE_') === 0; // See constants.ts in edit-common

export const isJSOnlyPreloadEditSources = (editSource: string) =>
	isLoadingFromCreate(editSource) || InitialLoadEditSources.includes(editSource);

export const isEditSourceInitialLoad = (editSource: string) =>
	InitialLoadEditSources.includes(editSource);
